import {
  Component,
  HostListener,
  Inject,
  Input, OnDestroy,
  OnInit
} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {
  Organiser,
  RequestFilter,
  RequestStatus,
  UserDetail, Request, Message, TOAST_STATE
} from "@model";
import {
  CONTACT_ROUTE,
  EVENT_CALENDAR_ROUTE,
  FINISHED_EVENTS_ROUTE,
  LANDING_ROUTE,
  LIVE_RESULTS,
  LOGIN_ROUTE,
  PRIVATE_EVENT_CALENDAR_ROUTE,
  PRIVATE_FINISHED_EVENTS_ROUTE,
  PRIVATE_LIVE_RESULTS,
  SIGNUP_ROUTE,
  USER_MESSAGES,
  SERIES_ROUTE,
  PRIVATE_SERIES_ROUTE,
  ORGANISER_EVENTS,
  MY_TRACEY,
  GENERAL_CONDITIONS_ROUTE,
  COOKIE_POLICY_ROUTE,
  INTELLECTUAL_PROPERTY_ROUTE,
  COMPLAINTS_AND_DISPUTES,
  PERSONAL_DATA_PROTECTION, MY_TRACEY_ORDERS, MY_TRACEY_EDIT
} from "src/app/app-routing.module";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {TranslocoService} from '@ngneat/transloco';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {
  AuthenticationService, LoaderService,
  MessageService,
  RequestService, ToastService,
  UserDetailService
} from "@services";
import {AbstractComponent} from "../abstract.component";
import {NewOrganiserModalComponent} from "../new-organiser-modal/new-organiser-modal.component";
import {DOCUMENT} from "@angular/common";
import {environment} from "@environment";
import {LanguagePickerModalComponent} from "../language-picker-modal/language-picker-modal.component";

@Component({
    selector: 'app-page-header-public-alt',
    templateUrl: './page-header-public-alt.component.html',
    styleUrls: ['./page-header-public-alt.component.scss'],
    animations: [
        trigger('slideInOut', [
          state('in', style({
            opacity: 1,
            transform: 'translate3d(0, 0, 0)'
          })),
          state('inLanding', style({
            opacity: 1,
            transform: 'translate3d(0, 0, 0)'
          })),
          state('out', style({
            opacity: 0,
            transform: 'translate3d(-100%, 0, 0)'
          })),
          transition('in => out', animate('300ms ease-out')),
          transition('out => in', animate('300ms ease-in')),
          transition('inLanding => out', animate('300ms ease-out')),
          transition('out => inLanding', animate('300ms ease-in'))
        ]),
        trigger('searchSlideInOut', [
            state('hidden', style({
                opacity: 0,
                transform: 'translateY(-100%)',
                display: 'none'
            })),
            state('visible', style({
                opacity: 1,
                transform: 'translateY(0)',
                display: 'flex'
            })),
            transition('hidden => visible', animate('300ms ease-in')),
            transition('visible => hidden', animate('200ms ease-out'))
        ])
    ],
    standalone: false
})
export class PageHeaderPublicAltComponent extends AbstractComponent implements OnInit, OnDestroy {
  @Input() additionalClass: string | undefined;
  @Input() isLanding: boolean = false;
  @Input() isTopBannerVisible: boolean = false;

  currentUserDetails: UserDetail | undefined;
  currentUrl: string = "";
  public currentWindowWidth: number = 0;
  isMobileMenuVisible: boolean = false;
  unreadMessages: Message[] | undefined;
  isSearchVisible: boolean = false;
  activeLang?: string;
  activeRoute: string = "";
  isLegalOpen: boolean = false;

  constructor(private router: Router, public authenticationService: AuthenticationService,
              private modalService: NgbModal, private requestService: RequestService,
              private userService: UserDetailService, private translocoService: TranslocoService,
              private messageService: MessageService, @Inject(DOCUMENT) private document: Document,
              private loaderService: LoaderService, private toastService:ToastService) {
    super();
    if (this.isBrowser) {
      this.currentWindowWidth = window.innerWidth;
    }
  }

  ngOnInit(): void {
    this.activeLang = this.getLanguageName(this.translocoService.getActiveLang());

    this.subscriptions.push(this.userService.currentUserDetails.subscribe((userDetails: UserDetail | undefined): void => {
      this.currentUserDetails = userDetails;
    }));

    if (this.authenticationService.isAuthenticated()) {
      this.messageService.getUserMessages(false).subscribe((messages: Message[]) => {
        this.unreadMessages = messages;
      });
    }
    this.subscriptions.push(this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.setActiveRoute();
        this.setToggleActive();
      }
    }));
    this.setActiveRoute();
    this.setToggleActive();
  }

  setToggleActive() {
    if (this.activeRoute === GENERAL_CONDITIONS_ROUTE
        || this.activeRoute === PERSONAL_DATA_PROTECTION
        || this.activeRoute === INTELLECTUAL_PROPERTY_ROUTE
        || this.activeRoute === COMPLAINTS_AND_DISPUTES) {
      this.isLegalOpen = true
    }
  }

  override ngOnDestroy(): void {
    if (this.isBrowser) {
      this.document.body.classList.remove('overflow-hidden');
    }
  }

  goToMessages(messageFilter: boolean) {
    this.router.navigate([USER_MESSAGES], {queryParams: {read: messageFilter}});
  }

  toggleMobileMenuVisibility() {
    if (this.currentWindowWidth < 1400) {
      this.isMobileMenuVisible = !this.isMobileMenuVisible;

      if (this.isBrowser) {
        if (this.isMobileMenuVisible) {
          this.document.body.classList.add('overflow-hidden');
          this.isSearchVisible = false;
        } else {
          this.document.body.classList.remove('overflow-hidden');
        }
      }
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.currentWindowWidth = event.target.innerWidth;
  }

  goToLogin() {
    this.router.navigate([LOGIN_ROUTE]);
  }

  goToSignup() {
    this.router.navigate([SIGNUP_ROUTE]);
  }

  goToFinished() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([this.authenticationService.isAuthenticated() ? PRIVATE_FINISHED_EVENTS_ROUTE : FINISHED_EVENTS_ROUTE]);
  }

  goToLiveResults() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([this.authenticationService.isAuthenticated() ? PRIVATE_LIVE_RESULTS : LIVE_RESULTS]);
  }

  onClickToLogoImage() {
    if (this.isMobileMenuVisible) {
      this.toggleMobileMenuVisibility();
    }
    this.router.navigate([this.authenticationService.isAuthenticated() ? PRIVATE_EVENT_CALENDAR_ROUTE : LANDING_ROUTE]);
  }

  onEventCalendar() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([this.authenticationService.isAuthenticated() ? PRIVATE_EVENT_CALENDAR_ROUTE : EVENT_CALENDAR_ROUTE]);
  }

  goToSeries() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([this.authenticationService.isAuthenticated() ? PRIVATE_SERIES_ROUTE : SERIES_ROUTE]);
  }

  logout() {
    this.toggleMobileMenuVisibility();
    this.authenticationService.logout();
  }


  goToMyTracey() {
    //this.toggleMobileMenuVisibility();
    this.router.navigate([MY_TRACEY]);
  }

  goToOrders() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([MY_TRACEY_ORDERS]);
  }

  setActiveRoute(): void {
    this.currentUrl = this.document.location.href;

    const routes = [
      EVENT_CALENDAR_ROUTE,
      FINISHED_EVENTS_ROUTE,
      CONTACT_ROUTE,
      LIVE_RESULTS,
      SIGNUP_ROUTE,
      SERIES_ROUTE,
      GENERAL_CONDITIONS_ROUTE,
      PERSONAL_DATA_PROTECTION,
      INTELLECTUAL_PROPERTY_ROUTE,
      COMPLAINTS_AND_DISPUTES,
      COOKIE_POLICY_ROUTE,
      MY_TRACEY_EDIT,
      MY_TRACEY,
      LANDING_ROUTE
    ];

    this.activeRoute = routes.find(route => this.currentUrl.includes(route)) ?? this.activeRoute;
  }

  goToPrivacy(url: string) {
    this.toggleMobileMenuVisibility();
    this.router.navigate([url]);
  }

  goToContact() {
    this.router.navigate([CONTACT_ROUTE]);
  }

  goToEditProfile(){
    this.router.navigate([MY_TRACEY_EDIT]);
  }

  onOrganiserButtonClick() {
    if (this.authenticationService.isAdminModuleAvailable()) {
      this.goToOrganizerModule();
    } else {
      this.openOrganiserRequestModule();
    }
  }

  private goToOrganizerModule() {
    this.router.navigate([ORGANISER_EVENTS]);
  }

  private openOrganiserRequestModule() {
    this.requestService.fetchRequestsCount(new RequestFilter(RequestStatus.ON_HOLD, this.currentUserDetails?.userId)
    ).subscribe((count: number) => {
      let organiserRequestSent: boolean = (count ?? 0) > 0;

      const windowClasses = ['new-organiser-modal'];
      if (organiserRequestSent) {
        windowClasses.push('new-organiser-modal--request-sent');
      }

      const modalRef: NgbModalRef = this.modalService.open(NewOrganiserModalComponent, {
        centered: true,
        windowClass: windowClasses.join(' ')
      });
      modalRef.componentInstance.title = this.translocoService.translate("request.header.title");
      modalRef.componentInstance.requestSent = organiserRequestSent;
      modalRef.result.then((organiser: Organiser): void => {
        this.loaderService.startLoading()
        this.requestService.sendOrganiserRequest(Request.createOrganiserRequest(organiser), () => {
          this.loaderService.dismissLoading()
          this.toastService.showToast(TOAST_STATE.success,
            this.translocoService.translate("newOrganiser.request.sent.success"));
        }, (errorCode?: number) => {
          this.loaderService.dismissLoading()
          if (errorCode === RequestService.EXISTING_ORGANISER_REQUEST_ON_HOLD) {
              this.toastService.showToast(TOAST_STATE.danger,
                this.translocoService.translate("newOrganiser.request.alreadySent"));
            } else {
              this.toastService.showToast(TOAST_STATE.danger,
                this.translocoService.translate("newOrganiser.request.alreadySent.error"));
            }
        });
      }, (_: any): void => {
        /// on modal dismiss, ignore
      });
    });
  }

  toggleSearch() {
    this.isSearchVisible = !this.isSearchVisible;
  }

  getLanguageName(activeLang: string) {
    switch (activeLang) {
      case "en":
        return 'EN';
      case "hr":
        return 'HR';
      case "slo":
        return 'SLO';
      case "sr":
        return 'SR';
      case "bs":
        return 'BS';
      case "it":
        return 'IT';
      case "de":
        return 'DE';
      case "fr":
        return 'FR';
      case "es":
        return 'ES';
    }
    return activeLang;
  }

  openLanguagesModal() {
    const modalRef =  this.modalService.open(LanguagePickerModalComponent, {
      centered: true,
      size: 'lg',
    });
  }

  toggleLegal() {
    this.isLegalOpen = !this.isLegalOpen;
  }

  protected readonly environment = environment;


  protected readonly SIGNUP_ROUTE: string = SIGNUP_ROUTE;
  protected readonly LANDING_ROUTE: string = LANDING_ROUTE;
  protected readonly MY_TRACEY_EDIT: string = MY_TRACEY_EDIT;
  protected readonly EVENT_CALENDAR_ROUTE: string = EVENT_CALENDAR_ROUTE;
  protected readonly FINISHED_EVENTS_ROUTE: string = FINISHED_EVENTS_ROUTE;
  protected readonly LIVE_RESULTS: string = LIVE_RESULTS;
  protected readonly SERIES_ROUTE: string = SERIES_ROUTE;
  protected readonly CONTACT_ROUTE: string = CONTACT_ROUTE;
  protected readonly GENERAL_CONDITIONS_ROUTE: string = GENERAL_CONDITIONS_ROUTE;
  protected readonly COOKIE_POLICY_ROUTE: string = COOKIE_POLICY_ROUTE;
  protected readonly INTELLECTUAL_PROPERTY_ROUTE: string = INTELLECTUAL_PROPERTY_ROUTE;
  protected readonly COMPLAINTS_AND_DISPUTES: string = COMPLAINTS_AND_DISPUTES;
  protected readonly PERSONAL_DATA_PROTECTION: string = PERSONAL_DATA_PROTECTION;
  protected readonly MY_TRACEY: string = MY_TRACEY;
  protected readonly MY_TRACEY_ORDERS: string = MY_TRACEY_ORDERS;
}
